import { Option } from '../types/common-types'
import { PassportType } from '../enums/passportTypeEnum'

export const passportTypeKz: Option[] = [
  {
    value: PassportType.IdentityCard,
    label: {
      eng: 'Identification',
      rus: 'Уд. личности',
      kz: 'Жеке куәлік',
    },
  },
]

export const passportTypeKzForRf: Option[] = [
  {
    value: PassportType.IdentityCard,
    label: {
      eng: 'Identification',
      rus: 'Уд. личности',
      kz: 'Жеке куәлік',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
  {
    value: PassportType.Passport,
    label: {
      eng: 'Passport of Kazakhstan',
      rus: 'Паспорт Казахстана',
      kz: 'Қазақстан Паспорты',
    },
  },
]

export const passportTypeRfForKz: Option[] = [
  {
    value: PassportType.InternationalPassport,
    label: {
      eng: 'International passport',
      rus: 'Заграничный паспорт',
      kz: 'Шетелдік төлқұжат',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
  // {
  //   value: PassportType.TempResidencePermit,
  //   label: {
  //     eng: 'Temp. residence permit',
  //     rus: 'РВП',
  //     kz: 'Уақытша тұруға рұқсат',
  //   },
  // },
  {
    value: PassportType.Passport,
    label: {
      eng: 'Internal passport',
      rus: 'Внутренний паспорт РФ',
      kz: 'Ішкі төлқұжат',
    },
  },
]
export const passportTypeRf: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Internal passport',
      rus: 'Внутренний паспорт РФ',
      kz: 'Ішкі төлқұжат',
    },
  },
]
export const passportTypeKgz: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Biometric passport',
      rus: 'Биометрический паспорт',
      kz: 'Биометриялық төлқұжат',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
  // {
  //   value: PassportType.TempResidencePermit,
  //   label: {
  //     eng: 'Temp. residence permit',
  //     rus: 'РВП',
  //     kz: 'Уақытша тұруға рұқсат',
  //   },
  // },
  {
    value: PassportType.IdCard,
    label: {
      eng: 'ID card',
      rus: 'ID карта',
      kz: 'Жеке куәлік',
    },
  },
]

export const passportTypeArm: Option[] = [
  {
    value: PassportType.IdCard,
    label: {
      eng: 'ID card',
      rus: 'ID карта',
      kz: 'Жеке куәлік',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
  {
    value: PassportType.Passport,
    label: {
      eng: 'Biometric passport',
      rus: 'Биометрический паспорт',
      kz: 'Биометриялық төлқұжат',
    },
  },
]

export const passportTypeGbr: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'British Passport',
      rus: 'Паспорт гражданина Великобритании',
      kz: 'Ұлыбритания азатының төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]
export const passportTypeBel: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Biometric passport',
      rus: 'Биометрический паспорт',
      kz: 'Биометриялық төлқұжат',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
  {
    value: PassportType.IdCard,
    label: {
      eng: 'ID card',
      rus: 'ID карта',
      kz: 'Жеке куәлік',
    },
  },
]

export const passportTypeBelForRf: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Biometric passport',
      rus: 'Биометрический паспорт',
      kz: 'Биометриялық төлқұжат',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
  {
    value: PassportType.IdCard,
    label: {
      eng: 'ID card',
      rus: 'ID карта',
      kz: 'Жеке куәлік',
    },
  },
]

export const passportTypeRom: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Simple electronic passport',
      rus: 'Простой электронный паспорт',
      kz: 'Қарапайым электрондық төлқұжат',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeGer: Option[] = [
  {
    value: PassportType.InternationalPassport,
    label: {
      eng: 'International passport',
      rus: 'Заграничный паспорт',
      kz: 'Халықаралық паспорт',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeUkr: Option[] = [
  {
    value: PassportType.InternationalPassport,
    label: {
      eng: 'International passport',
      rus: 'Заграничный паспорт',
      kz: 'Халықаралық паспорт',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeUkrForRf: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Internal passport',
      rus: 'Внутренний паспорт',
      kz: 'Ішкі төлқұжат',
    },
  },
  {
    value: PassportType.IdCard,
    label: {
      eng: 'ID card',
      rus: 'ID карта',
      kz: 'Жеке куәлік',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
  {
    value: PassportType.InternationalPassport,
    label: {
      eng: 'International passport',
      rus: 'Заграничный паспорт',
      kz: 'Халықаралық паспорт',
    },
  },
]

export const passportTypeUsa: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'United States Passport',
      rus: 'Паспорт гражданина США',
      kz: 'АҚШ төлқұжаты ',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeAus: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Australian passport',
      rus: 'Паспорт гражданина Австралии',
      kz: 'Австралия азаматының төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeTaj: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Tajikistan passport',
      rus: 'Паспорт Таджикистана',
      kz: 'Тәжікстан төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeTkm: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Turkmen passport',
      rus: 'Туркменский паспорт',
      kz: 'Түрікменстан төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeTur: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Turkish Passport',
      rus: 'Турецкий паспорт',
      kz: 'Түрік төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]
export const passportTypeGeo: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Georgian passport',
      rus: 'Грузинский паспорт',
      kz: 'Грузин төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]
export const passportTypeFra: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'French passport',
      rus: 'Французский паспорт',
      kz: 'Француз төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]
export const passportTypeVnm: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Vietnamese passport',
      rus: 'Вьетнамский паспорт',
      kz: 'Вьетнам төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]
export const passportTypeEsp: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Spanish passport',
      rus: 'Испанский паспорт',
      kz: 'Испанский паспорт',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]
export const passportTypeIrn: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Iranian passport',
      rus: 'Паспорт гражданина Ирана',
      kz: 'Иран азаматының төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]
export const passportTypeNga: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Nigerian passport',
      rus: 'Паспорт гражданина Нигерии',
      kz: 'Нигерия азаматының төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]
export const passportTypeChn: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Chinese passport',
      rus: 'Паспорт Китая',
      kz: 'Қытай азаматының төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]
export const passportTypeUzb: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Uzbekistan Passport',
      rus: 'Паспорт Узбекистана',
      kz: 'Passport of Uzbekistan',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypePrk: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'South Korean passport',
      rus: 'Южнокорейский паспорт',
      kz: 'Южнокорейский паспорт',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeLitva: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: "Citizen's passport",
      rus: 'Паспорт гражданина',
      kz: 'Азаматтың төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeSKorea: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: "South Korean passport",
      rus: 'Паспорт гражданина Южной Кореи',
      kz: 'Оңтүстік Корея төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeIndia: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Indian passport',
      rus: 'Паспорт гражданина Индии',
      kz: 'Үндістанның төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypePakistan: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Pakistani passport',
      rus: 'Пакистанский паспорт',
      kz: 'Пәкістан азаматының төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]


export const passportTypeLatvia: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: "Latvian passport",
      rus: 'Латвийский паспорт',
      kz: 'Латвия төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeBrunei: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Bruneian passport',
      rus: 'Паспорт гражданина Брунея',
      kz: 'Бруней азаматының төлқұжаты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const passportTypeSwe: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Swedish passport',
      rus: 'Шведский паспорт',
      kz: 'Швед паспорты',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]

export const DocumentTypeValuesUdvAbroad: Option[] = [
  {
    value: PassportType.InternationalPassport,
    label: {
      eng: 'International passport',
      rus: 'Заграничный паспорт',
      kz: 'Халықаралық паспорт',
    },
  },
  {
    value: PassportType.ResidencePermit,
    label: {
      eng: 'Residence permit',
      rus: 'Вид на жительство',
      kz: 'Тұруға ықтиярхат',
    },
  },
]
export const DocumentTypeValuesTypePersonalities: Option[] = [
  {
    value: PassportType.IdentityCard,
    label: {
      eng: 'Oud. personalities',
      rus: 'Уд. личности',
      kz: 'Оуд. тұлғалар',
    },
  },
]
export const DocumentTypeValuesTypePassport: Option[] = [
  {
    value: PassportType.Passport,
    label: {
      eng: 'Passport',
      rus: 'Паспорт',
      kz: 'Паспорт',
    },
  },
]

export const BritishCodeType: Option[] = [
  {
    value: 'GBR',
    label: {
      eng: 'GBR',
      rus: 'GBR',
      kz: 'GBR',
    },
  },
  {
    value: 'GBD',
    label: {
      eng: 'GBD',
      rus: 'GBD',
      kz: 'GBD',
    },
  },
  {
    value: 'GBO',
    label: {
      eng: 'GBO',
      rus: 'GBO',
      kz: 'GBO',
    },
  },
  {
    value: 'GBS',
    label: {
      eng: 'GBS',
      rus: 'GBS',
      kz: 'GBS',
    },
  },
  {
    value: 'GBP',
    label: {
      eng: 'GBP',
      rus: 'GBP',
      kz: 'GBP',
    },
  },
  {
    value: 'GBN',
    label: {
      eng: 'GBN',
      rus: 'GBN',
      kz: 'GBN',
    },
  },
]
